import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RdsVariableDistributionComponent } from './variable-distribution';
import { RdsNumberTruncPipe } from './variable-distribution.pipe';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatTooltipModule],
  declarations: [RdsVariableDistributionComponent, RdsNumberTruncPipe],
  exports: [RdsVariableDistributionComponent, RdsNumberTruncPipe]
})
export class RdsVariableDistributionModule {}

export * from './variable-distribution';
export * from './variable-distribution.pipe';
